import { Fragment } from "react";
import { ParagraphProps } from "../../Types/CommonElementType";

const P: React.FC<ParagraphProps> = (props) => {
  return (
    <Fragment>
      <p {...props} style={{
        color: "var(--theme-body-font-color)",
        ...props.style,
      }}>
        {props.children}
      </p>
    </Fragment>
  );
};

export default P;
